import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/ShopOEByBrands.css";
import { axiosGet } from "../../Apis/axiosMethods";

const ShopByOEBrands = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [suppliersLimit, setSuppliersLimit] = useState(24);

    const { gdcURL } = useContext(ConfigContext);

    const [loading, setLoading] = useState(true);
    const [pc_id] = useState(localStorage.getItem("pc_id"));
    const [car_info] = useState(localStorage.getItem("car_info") ? JSON.parse(localStorage.getItem("car_info")) : []);

    const dir = localStorage.getItem("dir");
    const navigate = useNavigate();

    // ================= FETCH SUPPLIERS =================

    const fetchSuppliers = async () => {
        try {
            setLoading(true);

            const response = await axiosGet(`/Parts/${pc_id ? "GetGenuinePartsWithCarAvailableCounts" : "GetGenuinePartsWithoutCarAvailableCounts"}`, {
                pc_id,
                brand: car_info[0]?.MFA_BRAND
            }
            );
            if (response?.data?.success) {
                setSuppliers(response.data.data);
            }
        } catch (error) {
            console.log("Error loading supplier brands:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSuppliers();
    }, [car_info]);


    return (
        <section className="blog-section pb-0">
            {
                (suppliers?.length > 0) > 0 &&
                <div className="container">

                    <div className="oe-header">
                        <h3 className="oe-brand-title">
                            GHAYAR AUTO PARTS STORE: SHOP BY GENUINE BRANDS
                        </h3>
                    </div>

                    <div className="row brand-grid">
                        {
                            suppliers.slice(0, suppliersLimit).map((sup, index) => (
                                sup?.stock_brand_name && (
                                    <span key={`supplier-${index}`}>
                                        <div
                                            className="oe-brand-card"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                navigate(
                                                    `/Spare-Parts/PartsByOEBrand/${encodeURIComponent(
                                                        sup?.stock_brand_name
                                                    )}`
                                                );
                                            }}
                                        >
                                            <div className="parts-overlay d-flex gap-1 justify-content-center align-items-center">
                                                <div
                                                    style={{
                                                        background: "#cc000b",
                                                        borderRadius: "50%",
                                                        color: "#FFF",
                                                        width: "40px",
                                                        height: "40px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "12px",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    {sup.available_parts}
                                                </div>

                                                <div style={{ background: "#cc000b", padding: "5px 10px", borderRadius: "5px", color: "#FFF", marginLeft: "5px" }}>
                                                    Available Parts
                                                </div>
                                            </div>
                                            <ImageWithFallback
                                                src={`${gdcURL}/make_logo/${sup?.MFA_ID}.png`}
                                                // src={`${sup?.logo_url}`}
                                                alt={sup?.stock_brand_name}
                                                fallbackText={sup?.stock_brand_name}
                                            />
                                        </div>
                                    </span>
                                )
                            ))
                        }
                    </div>

                    {suppliers && suppliers.length > 24 && (
                        <center style={{ direction: dir === "rtl" ? "ltr" : "" }}>
                            <NavLink
                                className="show-more-btn"
                                onClick={() =>
                                    setSuppliersLimit(
                                        suppliersLimit === 24 ? suppliers.length : 24
                                    )
                                }
                            >
                                {suppliersLimit === 24 ? "View All Brands" : "Show Less"}
                            </NavLink>
                        </center>
                    )}
                </div>
            }
        </section>
    );
};

// ================= IMAGE FALLBACK =================

const ImageWithFallback = ({ src, alt, fallbackText }) => {
    const [imgError, setImgError] = useState(false);

    return (
        <div className="oe-brand-image-container">
            {imgError ? (
                <div className="fallback-text">{fallbackText}</div>
            ) : (
                <img
                    className="oe-brand-image"
                    src={src}
                    alt={alt}
                    onError={() => setImgError(true)}
                />
            )}
        </div>
    );
};

export default ShopByOEBrands;